import styled from '@emotion/styled';

export const WarningText = styled.div`
  margin: 16px 0;
  text-align: center;
  font-size: 16px;
`;
